"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AirplaneSVG = ({ className, fill = '#FFF', style, }) => {
    return (react_1.default.createElement("svg", { className: className, id: "airplane", style: style || { height: 59, width: 59 }, viewBox: "243.5 245.183 25 21.633" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: fill, d: "M251.966,266.816h1.242l6.11-8.784l5.711,0.2c2.995-0.102,3.472-2.027,3.472-2.308\n                      c0-0.281-0.63-2.184-3.472-2.157l-5.711,0.2l-6.11-8.785h-1.242l1.67,8.983l-6.535,0.229l-2.281-3.28h-0.561v3.566\n                      c-0.437,0.257-0.738,0.724-0.757,1.266c-0.02,0.583,0.288,1.101,0.757,1.376v3.563h0.561l2.281-3.279l6.535,0.229L251.966,266.816z\n                      " }))));
};
exports.default = AirplaneSVG;
